














































































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  FetchState,
} from "@/shared/types";
import { Validator } from "vee-validate";
import * as routeNames from "@/employee/route-names";
import moment from "moment";
import { LoginRouteNames } from "@/shared/loginRoutes";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useEbtoStore } from "@/shared/store/ebto";
import { useThemeStore } from "@/shared/store/theme";

const HsabPartnerId = 15;
@Component({
  components: {
    HsabLoginWrapper,
    GenericLoadingSpinner
  }
})
export default class EbtoClaim extends Vue {
  @Prop() campaignKey: string;

  portalCustomizationStore = usePortalCustomizationStore();
  ebtoStore = useEbtoStore();
  themeStore = useThemeStore();

  $validator: Validator;
  LoginRouteNames = LoginRouteNames;
  HsabPartnerId = HsabPartnerId;

  email = "";
  dateOfBirth = "";
  last4Social = "";
  firstName = "";
  lastName = "";

  get isLoaded () {
    return this.ebtoStore.isCampaignValidationLoaded && this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get isNextButtonDisabled () {
    return this.$validator.errors.any() || this.isSubmitting || this.isFormDisabled
        || this.firstName === "" || this.lastName === "" || this.last4Social === "" || this.dateOfBirth === "";
  }

  get isFormDisabled () {
    return this.isLoaded && this.ebtoStore.isValidCampaign === false;
  }

  get isSubmitting () {
    return this.ebtoStore.userSubmissionFetchState === FetchState.Loading;
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll()
        .then(result => {
          if (!result) {
            return;
          }
          this.ebtoStore.claimUserEbtoCampaign({
            campaignId: this.campaignKey,
            firstName: this.firstName,
            lastName: this.lastName,
            last4Ssn: this.last4Social,
            dateOfBirth: moment(this.dateOfBirth).format("YYYY-MM-DD"),
          }).then(() => {
            if (this.ebtoStore.verifiedUser === null || this.ebtoStore.verifiedUser.userId === 0) {
              // if user verification failed, don't proceed
              return;
            }
            this.$router.push({ name: routeNames.EbtoVerificationCode });
          });
        });
  }
}
